// extracted by mini-css-extract-plugin
export var lbContainerOuter = "B_tT";
export var lbContainerInner = "B_tV";
export var movingForwards = "B_tW";
export var movingForwardsOther = "B_tX";
export var movingBackwards = "B_tY";
export var movingBackwardsOther = "B_tZ";
export var lbImage = "B_t0";
export var lbOtherImage = "B_t1";
export var prevButton = "B_t2";
export var nextButton = "B_t3";
export var closing = "B_t4";
export var appear = "B_t5";